var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    _vm._b(
      { attrs: { placement: _vm.placement, "popper-class": _vm.$popperClass } },
      "el-tooltip",
      _vm.$attrs,
      false
    ),
    [
      _c("i", {
        staticClass: "qm-icon-question qm-explain__icon",
        style: { fontSize: _vm.size + "px" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }